import { Input, Loader, Loading, Subsection } from '@fourthwall/components';
import { useFormikContext } from '@fourthwall/utils/dist/formik';
import React from 'react';
import { useInternalDomain } from './hooks/useInternalDomain';
import * as S from './InternalDomain.styled';
export const InternalDomain = () => {
    const { isCheckingSlugAvailability, isChangingSlug, getDomainUrl, checkSlugAvailability } = useInternalDomain();
    const formik = useFormikContext();
    const handleInternalDomainBlur = (event) => {
        if (formik.values.internalDomain !== formik.initialValues.internalDomain) {
            checkSlugAvailability(formik.values.internalDomain, formik);
        }
        formik.getFieldProps('internalDomain').onBlur(event);
    };
    const renderInput = () => {
        if (isChangingSlug) {
            return (React.createElement(Input, { disabled: true, ...formik.getFieldProps('internalDomain'), value: getDomainUrl(formik.getFieldProps('internalDomain').value), append: React.createElement(S.AppendLoaderContainer, null,
                    React.createElement(Loader, null)), suggestion: "Your new domain is being processed. This usually takes about an hour." }));
        }
        return (React.createElement(Loading, { isLoading: isCheckingSlugAvailability, size: "small" },
            React.createElement(Input, { append: React.createElement(S.AppendContainer, null,
                    React.createElement("span", null, getDomainUrl())), disabled: isCheckingSlugAvailability, showAppend: true, ...formik.getFieldProps('internalDomain'), onBlur: handleInternalDomainBlur })));
    };
    return (React.createElement(Subsection, { title: "Fourthwall domain" },
        React.createElement(S.Container, null,
            React.createElement("p", null, "Change your free Fourthwall domain name for your site."),
            renderInput())));
};
